<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12">
        <div class="form-group ">
          <label for="long_description" class="">Additional details
            <span v-if="errorLongDescription" class="error">{{ errorLongDescription }}</span>
          </label>
          <trumbowyg id="long_description" style="height: 200px" v-model="question.long_description" :config="config"
                     class="form-control"></trumbowyg>
          <span class="help-block m-b-none">
            <template v-if="workflowId === 3">
                          Use this space to provide additional details such as: background, achievements, further work to be done, etc. You can also attach additional files below. Please check the confidentiality level of this information.
            </template>
            <template v-else>
              Use this space to provide additional details such as: background, constraints, tried/ alternative / discarded solutions, etc. You can also attach additional files below. Please check the confidentiality level of this information.
            </template>
          </span>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12" >
        <div class="form-group">
          <label>Measurable performance</label>
          <span class="help-block m-b-none" style="margin-bottom: 10px">If possible define performance metrics. You can enter as many as you want, but 2-3 are usually good enough.</span>
          <div v-for="(metric, key) in question.metrics" v-bind:key="key">
            <metrics :metric="metric" :removeMetric="removeMetric" :index="key" :workflowId="workflowId"/>
          </div>
          <div class="text-left" style="margin-top: 10px">
            <button class="btn btn-sm btn-outline btn-primary" v-on:click="addMetric" ><i class="fa fa-plus"></i>Add criteria</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-6" >
        <div class="form-group" >
          <label for="trl" class="required">Maturity Level
            <span v-if="errorTrl" class="error">{{ errorTrl }}</span>
          </label>
          <v-select2 v-if="trls" id="trl" :options="trls"  label="name" v-model="question.trl" />
          <span class="help-block m-b-none">Technology Readiness Level (TRL) (see e.g.<a href="https://en.wikipedia.org/wiki/Technology_readiness_level">definition</a>)</span>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6" >
        <div class="form-group " >
          <label for="timeline" class="required">Timeline
            <span v-if="errorTimeline" class="error">{{ errorTimeline }}</span>
          </label>
          <v-select2 v-if="timelines" d="timeline" :options="timelines" label="name" v-model="question.timeline"/>
          <span class="help-block m-b-none">
            <template v-if="workflowId === 3">When TRL applies</template>
            <template v-else>When TRL above applies / should apply</template>
          </span>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6" >
        <div class="form-group ">
          <label :class="{required : $auth.user().profile.id !== 2}">Intellectual Property Rights
            <span v-if="errorMaturities" class="error">{{ errorMaturities }}</span>
          </label>
          <div class="checkbox checkbox-info" v-for="(maturity, key) in maturities" :key="key">
            <input :id="'maturities'+key" type="checkbox" style="position: absolute; opacity: 0;" v-model="maturity.checked">
            <label :for="'maturities'+key" class="">
              <template v-if="workflowId === 3 && maturity.id === 5 "> sale </template>
              <template v-else-if="workflowId === 3 && maturity.id === 6 "> not applicable </template>
              <template v-else> {{maturity.name}} </template>
            </label>
          </div>
          <span class="help-block m-b-none">Describe your position (multiple selections allowed)</span>
        </div>

      </div>
      <div class="col-xs-12 col-sm-6" >
        <div class="form-group " v-if="workflowId !== 3">
          <label class="required">Proposal
            <span v-if="errorProposalRequests" class="error">{{ errorProposalRequests }}</span>
          </label>

          <div class="row">
            <div class="col-xs-12 col-sm-6"  v-for="(proposal, key) in proposalRequests" :key="key">
              <div class="checkbox checkbox-info" style="margin-top: 0">
                <input :id="'proposalRequests'+key" type="checkbox" style="position: absolute; opacity: 0;" v-model="proposal.checked" @change="proposalRequestChange(proposal)">
                <label :for="'proposalRequests'+key" v-html="proposal.label"></label>
              </div>
            </div>
          </div>
          <span class="help-block m-b-none">Points to be covered in a proposal for collaboration</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <div class="form-group " >
          <label for="startDate" class="required">Start date
            <span v-if="errorStartDate" class="error">{{ errorStartDate }}</span>
          </label>
          <date-picker id="startDate" v-model="question.start_date" :config="configDate" :class="{'has-error' : errorStartDate, 'has-success' : errorStartDate === false}" required autocomplete="off"/>
          <span class="help-block m-b-none">Confirm or modify the start date of this call</span>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div class="form-group ">
          <label for="endDate" class="required">End date
            <span v-if="errorEndDate" class="error">{{ errorEndDate }}</span>
          </label>
          <date-picker id="endDate" v-model="question.end_date" :config="configDate" :class="{'has-error' : errorEndDate, 'has-success' : errorEndDate === false}" required autocomplete="off"/>
          <span class="help-block m-b-none">Confirm or modify the end date of this call</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group ">
          <label for="files" class="">Additional Files
            <span v-if="errorFiles" class="error">{{ errorFiles }}</span>
          </label>
          <upload-file id="files" :files="question.files" :uploadFiles="uploadFiles" :type="question" :removeFile="removeFile"/>
          <span class="help-block m-b-none">Attach any additional file that might be of interest (specification, schematics,...). Please check confidentiality level.</span>
        </div>
      </div>

    </div>
  </div>
</template>

<style >

  label.required:after {content: " *"; color: red;}

  .trumbowyg-box.trumbowyg-editor-visible {
    min-height: 150px;
  }

  .trumbowyg-editor {
    min-height: 150px;
  }
  .trumbowyg-box {
    margin: 0;
  }

</style>
<script>

import Metrics from './Metrics'
import UploadFile from './UploadFile'
import DatePicker from 'vue-bootstrap-datetimepicker'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
import vSelect2 from '../../components/utils/select2'

export default {
  components: {UploadFile, Metrics, DatePicker, vSelect2},
  name: 'QuestionStep2',
  props: ['projectId', 'question', 'workflowId'],
  watch: {
    'question.maturities': function (val) {
      this.setMaturities()
    },
    'question.proposal_requests': function (val) {
      this.setProposalRequests()
    }
  },
  data () {
    return {
      errorLongDescription: null,
      errorMetrics: null,
      errorTrl: null,
      errorMaturities: null,
      errorProposalRequests: null,
      errorTimeline: null,
      errorFiles: null,
      errorStartDate: null,
      errorEndDate: null,
      maturities: [],
      proposalRequests: [],
      trls: [],
      timelines: [],
      uploadFiles: [],
      config: {
        autogrow: true
      },
      metrics: [],
      date: new Date(),
      configDate: {
        format: 'YYYY-MM-DD',
        useCurrent: false
      }

    }
  },
  methods: {
    proposalRequestChange: function (proposal) {
      if (proposal.id === 8 && proposal.checked === true) {
        this.proposalRequests = this.proposalRequests.map((item) => {
          item.checked = false
          return item
        })
        proposal.checked = true
      } else {
        this.proposalRequests = this.proposalRequests.map((item) => {
          if (item.id === 8) {
            item.checked = false
          }
          return item
        })
      }
    },
    upload: function () {
      return new Promise((resolve, reject) => {
        if (this.uploadFiles.length !== 0) {
          let data = new FormData()

          this.uploadFiles.forEach((file) => {
            data.append('files[]', file)
          })
          data.append('target', 'question_file')
          data.append('additional_path', this.question.id)

          this.axios.post('/files/', data).then((response) => {
            this.uploadFiles.forEach((file) => {
              if (typeof response.data.files[file.name] !== 'undefined') {
                this.question.files.push({filename: response.data.path + response.data.files[file.name]})
              }
            })
            this.uploadFiles = []
            resolve(response)
          }).catch((error) => {
            if (typeof error.response !== 'undefined' && error.response.status === 413) {
              this.$notify({
                type: 'danger',
                title: 'An error has occurred, max upload size is 10 Mo',
                placement: 'bottom-right'
              })
            }
            reject(error)
          })
        } else {
          resolve(null)
        }
      })
    },
    removeFile: function (file) {
      if (typeof file.id !== 'undefined') {
        this.axios.delete('file/question_file/' + file.id).then((response) => {
          this.$emit('input', Date.now())
        }).catch((error) => {

        })
      }
    },
    submitStep: function (requiredFields) {
      return new Promise((resolve, reject) => {
        let method = (this.question.id === null ? 'post' : 'patch')
        this.errorLongDescription = null
        this.errorMetrics = null
        this.errorTrl = null
        this.errorMaturities = null
        this.errorProposalRequests = null
        this.errorTimeline = null
        this.errorFiles = null
        this.errorStartDate = null
        this.errorEndDate = null

        this.upload().then((response) => {
          this.axios[method]('/question/' + (method === 'patch' ? this.question.id : ''), {
            project_id: this.projectId,
            step: 2,
            long_description: (this.question.long_description === null ? '' : this.question.long_description),
            trl: this.question.trl !== null ? this.question.trl.id : null,
            timeline: this.question.timeline !== null ? this.question.timeline.id : null,
            metrics: this.question.metrics,
            maturities: this.getMaturities(),
            proposal_requests: this.getProposalRequests(),
            files: this.question.files,
            start_date: this.question.start_date,
            end_date: this.question.end_date,
            required_fields: requiredFields
          })
            .then((response) => {
              resolve(response)
            })
            .catch((error) => {
              reject(error)
              let errors = error.response.data.errors

              if (typeof errors['long_description'] !== 'undefined') {
                this.errorLongDescription = errors['long_description'][0]
              } if (typeof errors['trl'] !== 'undefined') {
                this.errorTrl = errors['trl'][0]
              } if (typeof errors['timeline'] !== 'undefined') {
                this.errorTimeline = errors['timeline'][0]
              } if (typeof errors['maturities'] !== 'undefined') {
                this.errorMaturities = errors['maturities'][0]
              } if (typeof errors['metrics'] !== 'undefined') {
                this.errorRestraint = errors['metrics'][0]
              } if (typeof errors['proposal_requests'] !== 'undefined') {
                this.errorProposalRequests = errors['proposal_requests'][0]
              } if (typeof errors['files'] !== 'undefined') {
                this.errorFiles = errors['files'][0]
              } if (typeof errors['start_date'] !== 'undefined') {
                this.errorStartDate = errors['start_date'][0]
              } if (typeof errors['end_date'] !== 'undefined') {
                this.errorEndDate = errors['end_date'][0]
              }
            })
        }).catch((error) => {
          if (typeof error.response !== 'undefined') {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorFiles = errors['files'][0]
                break
            }
          }
          reject(error)
        })
      })
    },
    getResources: function () {
      this.axios.get('/question/maturities')
        .then((response) => {
          this.maturities = response.data
          this.setMaturities()
        })
        .catch((error) => {
        })
      this.axios.get('/question/proposalRequests')
        .then((response) => {
          this.proposalRequests = response.data
          this.setProposalRequests()
        })
        .catch((error) => {
        })
      this.axios.get('/question/trls')
        .then((response) => {
          this.trls = response.data
        })
        .catch((error) => {
        })
      this.axios.get('/question/timelines')
        .then((response) => {
          this.timelines = response.data
        })
        .catch((error) => {
        })
    },
    setMaturities: function () {
      this.maturities = this.maturities.map((maturity) => {
        this.question.maturities.forEach((questionMaturity) => {
          if (maturity.id === questionMaturity.id) {
            maturity.checked = true
          } else if (maturity.checked !== true) {
            maturity.checked = false
          }
        })
        return maturity
      })
    },
    getMaturities: function () {
      return this.maturities.filter((maturity) => {
        return maturity.checked
      })
    },
    setProposalRequests: function () {
      this.proposalRequests.forEach((proposal) => {
        proposal.checked = false
        this.question.proposal_requests.forEach((questionProposal) => {
          if (proposal.id === questionProposal.id) {
            proposal.checked = true
          }
        })
      })
    },
    getProposalRequests: function () {
      return this.proposalRequests.filter((proposal) => {
        return proposal.checked
      })
    },
    addMetric: function (event) {
      event.preventDefault()
      this.question.metrics.push({
        name: null,
        current: null,
        target: null
      })
    },
    removeMetric: function (event, index) {
      event.preventDefault()

      this.question.metrics.splice(index, 1)
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/QuestionStep2.vue